import React, {useEffect, useState} from "react";
import {
    BreadcrumbCom,
    CollapsedIcon,
    LeftBox,
    LHeader,
    LoginOut,
    SpanBread,
    SearchButton,
    ResetButton,
    AvatarCom,
} from "./Header.style";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
} from "@ant-design/icons";
import {changeCollapsed} from "@/store/modules/globalConstans.slice";

import {useAppDispatch, useAppSelector} from "@/store";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Modal, Form, Input, message, Switch} from "antd";
import FormItem from "antd/es/form/FormItem";
import {changePasswordAction} from "@/store/action/loginAction";
import {DownOutlined, GlobalOutlined} from "@ant-design/icons";
import type {MenuProps} from "antd";
import {Dropdown, Space} from "antd";
import {getSystemStatus, updateSystemStatus} from "@/api/modules/userManagement";
import {useTranslation} from "react-i18next";
import i18n, {
    AppLanguage,
    LANG_STORAGE_KEY,
    languageLabelMap,
} from "@/utils/locales/i18n";

interface UserInfo {
    nickname: string;
    userAvatarFileName: string;
}

export default function Header() {
    /**
     * 头部容器组件 */
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    // collapsed 控制菜单栏展开隐藏
    const {collapsed} = useAppSelector((state) => state.globalConstans);
    const location = useLocation();
    const navigator = useNavigate();
    const [passwordShow, setpasswordShow] = React.useState(false);
    const [systemStatus, setSystemStatus] = useState(0);
    const [systemStatusLoading, setSystemStatusLoading] = useState(false);
    const [passForm] = Form.useForm();
    let [loginUserInfo, setValue] = useState({} as UserInfo);
    const [langTitle, setLangTitle] = useState(
        languageLabelMap[(i18n.language as AppLanguage) || "en"] || "English"
    );

    const messagePushMap = ["新增推送消息", "发布推送消息", "编辑推送消息", "推送消息详情"];

    const breadcrumbNameMap: Record<string, string> = {
        "/admin/dataCenter": t("dataCenter"),
        "/userManagement": t("userManagement"),
        "/userManagement/userList": t("userList"),
        "/userManagement/groupManagement": t("Draw Record"),
        "/userManagement/circleOfFriends": t("Robot List"),
        "/userManagement/UserReporting": "用户举报",
        "/systemBilling": t("lottery manage"),
        "/systemBilling/withdrawalRequest": "提现申请",
        "/systemBilling/withdrawalRecord": "提现记录",
        "/systemBilling/redEnvelopeRecord": "红包记录",
        "/systemBilling/soloRedEnvelopeRecord": "私聊红包",
        "/systemBilling/groupRedEnvelopeRecord": "群聊红包",
        "/systemBilling/cashAccountDetails": t("create drawing periods"),
        "/systemBilling/cashToMarbles": t("Prize hub"),
        "/systemBilling/marblesRecovery": t("history drawing periods"),
        "/systemBilling/giftAccountDetails": t("winging recrod"),
        "/systemBilling/rechargeRecord": "充值记录",
        "/systemBilling/transferRecords": "转账记录",
        "/systemBilling/bonusPointExchange": "礼品积分兑换明细",
        "/systemBilling/cashSaveDetails": t("current drawing periods "),
        "/systemBilling/verifyCodes": "验证码查询",
        "/systemBilling/TransferSwitch": "功能開關",
        "/systemSetting": t("system account"),
        "/systemSetting/paySetting": "支付设置",
        "/systemSetting/integralSettings": "积分设置",
        "/systemSetting/rolesList": t("role management"),
        "/systemSetting/adminList": t("account management"),
        "/systemSetting/sensitive": "敏感词",
        "/systemSetting/operationRecord": "操作记录",
        "/systemSetting/versionManagement": "版本管理",
        "/systemSetting/addressConfiguretion": "相关地址配置",
        "/systemSetting/noticManagement": "轮播图管理",
        "/rechargeManagement": "充值管理",
        "/rechargeManagement/rechargeSetting": "银行卡充值渠道列表",
        "/rechargeManagement/rechargeRequest": "充值申请列表",
        "/rechargeManagement/rechargeRecord": "充值记录",
        "/rechargeManagement/BankList": "银行类型列表",
        "/rechargeManagement/rechargeMoneyConfig": "充值金额配置",
        "/onlineService": "在线客服",
        "/withdrawal": "提现管理",
        "/withdrawal/customWithdrawal": "客服提现管理",
        "/withdrawal/financeWithdrawal": "财务提现管理",
        "/helpCenter": "帮助中心",
        "/helpCenter/list": "帮助中心列表",
        "/helpCenter/HelpCenterType": "帮助中心分类",
        "/game": "游戏",
        "/game/gamemanager": "游戏列表",
        "/game/gamenews": "游戏资讯",
        "/game/gameoutOrinDetails": "游戏转出转入明细",
        "/noticManagement": "官方公告",
        "/integralManagement": "积分管理",
        "/integralManagement/integralSettings": "积分设置",
        "/integralManagement/integralWorks": "积分任务",
        "/substation": "子站管理",
        "/systemSetting/chargeOptions": "充值选项配置",
        "/merchantManagement": "商戶管理",
        "/merchantManagement/merchantList": "商戶列表",
        "/merchantManagement/merchantProductList": "商戶商品列表",
        "/merchantManagement/merchandiseAccountDetail": "商戶賬目明細",
        "/merchantManagement/salesperson": "業務員列表",
        "/merchantManagement/swiper": "商家輪播圖",
        "/merchantManagement/subscriberExchangeRecord": "用戶兌換記錄",
        "/merchantManagement/applicationForSettlementList": "申請結算列表",
        "/merchantManagement/businessLicenseReview": "營業執照審核",
        "/merchantManagement/settlementRecord": "結算記錄",
        "/systemSetting/changeInTheGiftAccount": "礼金账目变动",
        "/systemSetting/eventManagement": "活动管理",
        "/qrCodeManager": "二维码管理",
        "/qrCodeManager/qrCoderList": "持码人列表",
        "/qrCodeManager/qrCodeBatch": "二维码批次",
        "/systemSetting/integralConfig": "支付贈送積分配置",
        "/messagePush": "消息推送中心",
        "/messagePush/messagePush": "消息推送中心",
        "/messagePush/messagePushDetail": messagePushMap[location.state?.type],
        "/messagePush/messageDetail": "查看消息詳情",
    };

    const pathSnippets = location.pathname.split("/").filter((i) => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
        if (
            url === "/systemBilling" ||
            url === "/userManagement" ||
            url === "/roles" ||
            url === "/systemSetting" ||
            url === "/rechargeManagement" ||
            url === "/withdrawal" ||
            url === "/integralManagement" ||
            url === "/game" ||
            url === "/messagePush"
        ) {
            return {
                key: url,
                title: <SpanBread>{breadcrumbNameMap[url]}</SpanBread>,
            };
        }
        return {
            key: url,
            title: <Link to={url}>{breadcrumbNameMap[url]}</Link>,
        };
    });

    // 改变菜单栏显示隐藏状态的事件
    const changeCollapsedStatus = () => {
        dispatch(changeCollapsed(!collapsed));
    };

    const changeAppLanguage = (lang: AppLanguage) => {
        localStorage.setItem(LANG_STORAGE_KEY, lang);
        i18n.changeLanguage(lang);
        setLangTitle(languageLabelMap[lang]);
    };

    const languageItems: MenuProps["items"] = [
        {
            key: "en",
            label: t("English"),
            onClick: () => changeAppLanguage("en"),
        },
        {
            key: "zh",
            label: t("Chinese"),
            onClick: () => changeAppLanguage("zh"),
        },
        {
            key: "vn",
            label: t("Vietnam"),
            onClick: () => changeAppLanguage("vn"),
        },
    ];

    const items: MenuProps["items"] = [
        {
            label: (
                <LoginOut
                    onClick={() => {
                        passForm.resetFields();
                        setpasswordShow(true);
                    }}
                >
                    {t("Password change")}
                </LoginOut>
            ),
            key: "0",
        },
        {
            label: (
                <LoginOut
                    onClick={() => {
                        localStorage.removeItem("come-to-chant-token");
                        localStorage.removeItem("userInfoObject");
                        localStorage.removeItem("userInfo");
                        localStorage.removeItem("user_uid");
                        navigator("/login");
                    }}
                >
                    {t("Log out")}
                </LoginOut>
            ),
            key: "1",
        },
    ];

    const handleSystemStatus = (e) => {
        setSystemStatusLoading(true)
        updateSystemStatus({
            systemStatus: e ? 1 : 0
        }).then(res => {
            if (res.code === 1) {
                setSystemStatus(e ? 1 : 0)
                setSystemStatusLoading(false)
            }
        }).catch(err => {
            console.log('err', err)
        })
    }

    useEffect(() => {
        const storedValue = localStorage.getItem("userInfoObject");
        if (storedValue !== null) {
            loginUserInfo = JSON.parse(storedValue) as UserInfo;
            setValue(loginUserInfo);
        }

        getSystemStatus().then(res => {
            if (res.code === 1) setSystemStatus(res.data)
        })

    }, []);
    return (
        <LHeader>
            <LeftBox>

                <CollapsedIcon onClick={changeCollapsedStatus}>
                    {collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                </CollapsedIcon>
                <BreadcrumbCom items={extraBreadcrumbItems}/>
            </LeftBox>
            <div style={{marginRight: "40px", display: "flex", alignItems: "center"}}>
                <div style={{marginRight: "20px"}}>
                    <Switch loading={systemStatusLoading} checkedChildren={t("System stop")} unCheckedChildren={t("System on")}
                            onChange={handleSystemStatus}
                            value={systemStatus === 1}/>
                </div>
                <Dropdown menu={{items: languageItems}}>
                    <a onClick={(e) => e.preventDefault()} style={{color: "#886DFF", marginRight: "20px"}}>
                        <Space>
                            <GlobalOutlined />
                            <span>{t(langTitle)}</span>
                            <DownOutlined/>
                        </Space>
                    </a>
                </Dropdown>
                <Dropdown menu={{items}}>
                    <a onClick={(e) => e.preventDefault()} style={{color: "#886DFF"}}>
                        <Space>
                            <AvatarCom>
                            </AvatarCom>
                            <span>{loginUserInfo.nickname}</span>
                            <DownOutlined/>
                        </Space>
                    </a>
                </Dropdown>
            </div>
            <Modal
                open={passwordShow}
                footer={null}
                closable={false}
                title={t("Password change")}
            >
                <Form
                    form={passForm}
                    onFinish={(value: any) => {
                        const params: any = {
                            userId: localStorage.getItem("user_uid"),
                            newPassword: value.newPassword,
                            oldPassword: value.oldPassword,
                        };
                        dispatch(changePasswordAction(params)).then((res: any) => {
                            if (res.payload.code !== 0) {
                                localStorage.removeItem("come-to-chant-token");
                                localStorage.removeItem("user_uid");
                                localStorage.removeItem("userInfo");
                                message.success(t("passwordChangeSuccess"));
                                setTimeout(() => {
                                    navigator("/login");
                                }, 2000);
                            } else {
                                message.error(res.payload.error);
                            }
                        });
                    }}
                    onReset={() => {
                        setpasswordShow(false);
                    }}
                >
                    <FormItem label={t("Enter old password")} name="oldPassword">
                        <Input.Password></Input.Password>
                    </FormItem>
                    <FormItem label={t("Enter new password")} name="newPassword">
                        <Input.Password></Input.Password>
                    </FormItem>
                    <div style={{display: "flex", justifyContent: "space-around"}}>
                        <SearchButton htmlType="reset">{t("cancel")}</SearchButton>
                        <ResetButton htmlType="submit">{t("submit")}</ResetButton>
                    </div>
                </Form>
            </Modal>
        </LHeader>
    );
}
